import React from 'react';
import { Flex } from '@components';
import { Button, Select, Spin, Form, message, Modal, Input, InputNumber, DatePicker, Table, Upload, Icon, Checkbox, Col, Row, Steps } from 'antd';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import NextButton from '@pages/SelfHelp/common/nextIndex';
import './index.css';
import NHFormItem from '@components/common/NHFormItem';
import NHFetch from '@utils/NHFetch';
import { mkbz as mkbzRouteMap } from '@pages/Assembly/siderMenu/menuObj';
import Hint from '@pages/SelfHelp/common/hint';
import moment from 'moment';
import { getLoginUser, createUuid } from '@utils/NHCore';
import NHSelect from "@components/common/NHSelect";
const { Option } = Select;
const { TextArea } = Input;
const FormItem = Form.Item;
const Dragger = Upload.Dragger;
const CheckboxGroup = Checkbox.Group;
const { Step } = Steps;

/** 单条审核记录在步骤条中的状态：SHLX=0 为待审 wait，不通过类为 error，其余为 finish */
const getAuditStepStatus = item => {
    if (String(item.SHLX != null ? item.SHLX : '') === '0') {
        return 'wait';
    }
    const mc = String(item.SHLXMC || '');
    if (/不通过|驳回|拒绝|未通过|不同意/.test(mc)) {
        return 'error';
    }
    return 'finish';
};

const getAuditStepResultClassName = item => {
    const st = getAuditStepStatus(item);
    if (st === 'error') {
        return 'channelTjstsxy-auditStepValue is-error';
    }
    if (st === 'wait') {
        return 'channelTjstsxy-auditStepValue is-wait';
    }
    return 'channelTjstsxy-auditStepValue is-ok';
};

/** 结束节点：保留在步骤条中，但不展示审核结果/人/时间/意见等详情 */
const isEndAuditNode = item => String(item.SZJD || '').trim() === '结束';

// 生成通知弹窗文案，并将到期时间格式化为年月日
const buildNoticeContent = (hjxfdqsj) => {
    const dateText = hjxfdqsj && moment(hjxfdqsj).isValid() ? moment(hjxfdqsj).format('YYYY年MM月DD日') : '--';
    return `郑重说明：
    根据《天津天狮学院学生缴费管理规定》，故意欠费的学生不享有上课、考试等教育教学计划安排的各项活动和使用学校教育教学资源及评先评优，申请获得奖、助学金等资格。享有暂缓缴费的学生不得有过度消费行为，不得有违反校规校纪行为等，一经查实，若无改进，停止其享有缓缴学费资格。
    本人及家长已知晓上述有关欠费后果的情况说明并承诺在${dateText}前交齐所欠学费，如未按时交齐所欠学费，所产生的后果由学生本人负责。 
`;
};

/** 办理银行：其他商业银行 / 其他预设银行 / 国家开发银行 */
const BLYH_QT_SYYH = 'QT_SYYH';
const BLYH_QT_YSYH = 'QT_YSYH';
const BLYH_GJKFYH = '01';

// 根据菜单节点生成“下一步”跳转地址
function buildMenuStepUrl(menu) {
    if (!menu) {
        return { url: '', search: '' };
    }
    const hjdm = menu.HJDM;
    if (hjdm.indexOf('GD') === 0) {
        return { url: mkbzRouteMap[hjdm] || '', search: `pkid=${menu.PKID}` };
    }
    if (hjdm.indexOf('ZDY') === 0) {
        return { url: '/customLink', search: `pkid=${menu.PKID}&mkbz=${hjdm}&lx=${menu.LX}` };
    }
    if (hjdm.indexOf('DCWJ') === 0) {
        return { url: '/customizeExamination', search: `pkid=${menu.PKID}&mkbz=${hjdm}` };
    }
    return { url: '', search: '' };
}

@Form.create()
export default class ChannelTjstsxy extends React.Component {
    constructor(props) {
        super(props);
        this.sjfyCalcTimer = null;
        this.state = {
            mkbz: 'GD005_26',
            hjmc: '',
            loading: false,
            nextUrl: '',
            search: '',
            noticeVisible: true,
            noticeConfirmed: false,
            hasSaved: false,
            needLateFee: '0',
            hjxfdqsj_csbz: 'TJSTSXY_YX_LSTD_HJXFDQSJ',
            hjxfdqsj: '',
            feeDetailList: [],
            linkHandled: false,
            /** 已办理时等 queryChannel 完成后再挂载表单，以便 NHFormItem initialValue 生效 */
            echoFormReady: true,
            /** queryChannel 等接口返回的详情，用于回显 */
            data: {},
            /** 材料上传：与自助报到 channel 页一致，由 state.fileList + 表单 fj:{fileList} 双写 */
            fileList: [],
            uploading: false,
            previewVisible: false,
            previewImage: '',
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'],
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'],
            checkGroup: [], //绿色通道办理原因
            /** 环节已办理时 getAuditData 返回的审核记录 */
            auditData: [],
        };
    }

    componentDidMount() {
        this.loadLstdBlyy();
        this.getFeeDetailList();
        this.queryQztjAndYlhj();
        this.checkIsZzbdHjLinked();
        this.getHjxfdqsj();
    }

    componentWillUnmount() {
        // this.loadLstdBlyy();
        if (this.sjfyCalcTimer) {
            clearTimeout(this.sjfyCalcTimer);
        }
    }

    loadLstdBlyy = () => {
        NHFetch('front/zhxg-unauth/yxwz/proData/selectDataList', 'get', 'sign=dmk_YXXT_LSTD_BLYY').then(res => {
            if (res && res.data) {
                let col = []
                res.data.map(item => {
                    col.push(
                        <Col span={12}>
                            <Checkbox value={item.VALUE}>{item.LABEL}</Checkbox>
                        </Col>
                    )
                })
                let html = <Row>{col}</Row>
                console.log('col', col)
                this.setState({ checkGroup: html })
            }
        })
    }

    /** 已办理时从 state.data 取 NHFormItem initialValue（仅 linkHandled 且已有详情） */
    initEcho = pick => {
        const { data, linkHandled } = this.state;
        if (!linkHandled || !data || typeof data !== 'object') {
            return undefined;
        }
        return pick(data);
    };

    // 金额字段统一转为 number，空值和非法值按 0 处理
    toAmountNumber = value => {
        if (value === null || value === undefined || value === '') {
            return 0;
        }
        const num = Number(value);
        return Number.isNaN(num) ? 0 : num;
    };

    /** 应缴学费数值：feeDetailList 中 FYLXM 为 01 的 YSJE 之和 */
    getYjxfAmountNumber = feeDetailList => {
        if (!Array.isArray(feeDetailList) || feeDetailList.length === 0) {
            return 0;
        }
        return feeDetailList.reduce((sum, item) => {
            if (!item) return sum;
            const fylxm = item.FYLXM != null ? String(item.FYLXM).trim() : '';
            if (fylxm !== '01') return sum;
            return sum + this.toAmountNumber(item.YSJE);
        }, 0);
    };

    /** 实缴费用计算基数：FYLXM 为 01、BX、ZS 的 YSJE 之和 */
    getSjfyBaseAmountNumber = feeDetailList => {
        if (!Array.isArray(feeDetailList) || feeDetailList.length === 0) {
            return 0;
        }
        const sjfyFylxmSet = new Set(['01', 'BX', 'ZS']);
        return feeDetailList.reduce((sum, item) => {
            if (!item) return sum;
            const fylxm = item.FYLXM != null ? String(item.FYLXM).trim() : '';
            if (!sjfyFylxmSet.has(fylxm)) return sum;
            return sum + this.toAmountNumber(item.YSJE);
        }, 0);
    };

    /** 应缴学费展示值（供 initialValue / setFieldsValue 共用） */
    getYjxfDisplayValue = feeDetailList => this.getYjxfAmountNumber(feeDetailList).toFixed(2);

    // 回填“应缴学费”：FYLXM 为 01 的明细 YSJE 相加
    updateYjxf = feeDetailList => {
        const { form } = this.props;
        form.setFieldsValue({
            yjxf: this.getYjxfDisplayValue(feeDetailList),
        });
    };

    /** 已办理时实缴费用展示：取 queryChannel 返回的 SJFY */
    getEchoSjfyDisplayValue = () => {
        const { data, linkHandled } = this.state;
        const raw = !linkHandled && data.SJFY != null ? data.SJFY : 0;
        const n = this.toAmountNumber(raw);
        return Number.isNaN(n) ? '0.00' : n.toFixed(2);
    };

    // 回填“实缴费用”：已办理直接取 queryChannel 的 SJFY；未办理按 FYLXM 01/BX/ZS 的 YSJE 之和扣助学贷款与缓交
    updateSjfy = feeDetailList => {
        const { form } = this.props;
        const { linkHandled } = this.state;

        if (linkHandled) {
            const display = this.getEchoSjfyDisplayValue();
            form.setFieldsValue({
                sjfy: display != null ? display : '0.00',
            });
            return;
        }

        const currentFeeDetailList = Array.isArray(feeDetailList) ? feeDetailList : this.state.feeDetailList;
        const sjfyBase = this.getSjfyBaseAmountNumber(currentFeeDetailList);
        const sfblzxdk = form.getFieldValue('sfblzxdk');
        const sfblhjxf = form.getFieldValue('sfblhjxf');
        const jtyh = form.getFieldValue('jtyh');
        const isHljyh = String(jtyh || '').toLowerCase() === 'hljyh';
        const loanAmount = sfblzxdk === '1' && !isHljyh ? this.toAmountNumber(form.getFieldValue('zxdkje')) : 0;
        const lateFeeAmount = sfblhjxf === '1' ? this.toAmountNumber(form.getFieldValue('hjxfje')) : 0;
        const rawSjfy = sjfyBase - loanAmount - lateFeeAmount;
        const sjfy = Number.isNaN(rawSjfy) ? 0 : Math.max(0, rawSjfy);
        form.setFieldsValue({
            sjfy: sjfy.toFixed(2),
        });
    };

    // 输入变更时延迟重算实缴费用，避免频繁计算
    updateSjfyDebounced = () => {
        // 用户有输入变化但尚未保存，则隐藏“下一步”，只保留“保存”
        if (this.state.hasSaved) {
            this.setState({ hasSaved: false });
        }
        if (this.sjfyCalcTimer) {
            clearTimeout(this.sjfyCalcTimer);
        }
        this.sjfyCalcTimer = setTimeout(() => {
            this.updateSjfy();
        }, 300);
    };

    // 查询收费明细，并在成功/失败后同步更新应缴学费与实缴费用
    getFeeDetailList = () => {
        const xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            return;
        }
        NHFetch('/jfxt/getFeeDetailList', 'GET')
            .then(res => {
                if (res && res.code === 200 && Array.isArray(res.data)) {
                    this.setState({ feeDetailList: res.data }, () => {
                        this.updateYjxf(res.data);
                        this.updateSjfy(res.data);
                    });
                } else {
                    this.setState({ feeDetailList: [] }, () => {
                        this.updateYjxf([]);
                        this.updateSjfy([]);
                    });
                }
            })
            .catch(() => {
                this.setState({ feeDetailList: [] }, () => {
                    this.updateYjxf([]);
                    this.updateSjfy([]);
                });
                message.error('获取收费明细失败');
            });
    };

    feeDetailColumns = [
        { title: '序号', dataIndex: 'ROW_ID', key: 'ROW_ID', },
        { title: '收费项目名称', dataIndex: 'SFXMMC', key: 'SFXMMC', },
        {
            title: '应收金额',
            dataIndex: 'YSJE',
            key: 'YSJE',
            render: v => (v === null || v === undefined ? '—' : Number(v).toFixed(2)),
        },
        {
            title: '实收金额',
            dataIndex: 'SSJE',
            key: 'SSJE',
            render: v => (v === null || v === undefined ? '—' : Number(v).toFixed(2)),
        },
        {
            title: '欠费金额',
            dataIndex: 'QFJE',
            key: 'QFJE',
            render: v => (v === null || v === undefined ? '—' : Number(v).toFixed(2)),
        },
    ];

    // 查询当前环节基础信息（用于页面加载态与环节流程）
    queryQztjAndYlhj = () => {
        const xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            return;
        }
        const zzbdhjid = this.getQueryString('pkid');
        this.setState({ loading: true });
        NHFetch('/zzbd/queryQztjAndYlhj', 'GET', { xsid, zzbdhjid })
            .then(res => {
                this.setState({ loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    };

    // 查询当前环节是否已办理（兼容 boolean 和 {data:boolean} 两种返回结构）
    checkIsZzbdHjLinked = () => {
        const xsid = getLoginUser() ? getLoginUser().userId : '';
        const zzbdhjid = this.getQueryString('pkid');
        if (!xsid) {
            this.setState({
                linkHandled: false,
                noticeVisible: true,
                noticeConfirmed: false,
                echoFormReady: true,
            });
            return;
        }
        NHFetch('/zzbdCommon/checkIsZzbdHjLinked', 'GET', { xsid, zzbdhjid }).then(res => {
            // 兼容返回布尔值或 { data: boolean } 两种结构
            const linked = typeof res === 'boolean' ? res : !!(res && res.data);
            this.setState({
                linkHandled: linked,
                noticeVisible: !linked,
                noticeConfirmed: linked,
                echoFormReady: !linked,
            }, () => {
                if (linked) {
                    this.queryChannel();
                }
            });
        });
    };

    getAuditData = lstdid => {
        NHFetch(`api/zhxg-yxxt/tjstsxy/getLstdAuditInfo?lstdid=${lstdid}`, 'GET')
            .then(res => {
                if (res && res.code === 200 && res.data) {
                    this.setState({ auditData: res.data });
                    return;
                }
            })
    }

    // 环节已办理时查询已保存的绿色通道数据，用于页面回显（仅查看）
    queryChannel = () => {
        const xsid = getLoginUser() ? getLoginUser().userId : '';
        const zzbdhjid = this.getQueryString('pkid');
        if (!xsid) {
            return;
        }
        NHFetch('/tjstsxy/queryChannel', 'GET', { xsid, zzbdhjid: zzbdhjid || '' })
            .then(res => {
                if (!res || res.code !== 200 || !res.data) {
                    this.setState({ echoFormReady: true });
                    return;
                }
                let lstdid = res.data.PKID;
                this.getAuditData(lstdid);
                const d = res.data;
                const sfblhjxf = d.SFBLHJXF != null ? String(d.SFBLHJXF) : '0';
                this.setState({ needLateFee: sfblhjxf, data: d, echoFormReady: true }, () => {
                    setTimeout(() => {
                        this.updateYjxf(this.state.feeDetailList);
                        this.updateSjfy();
                    }, 0);
                });
            })
            .catch(() => {
                this.setState({ echoFormReady: true });
            });
    };

    // 从 URL 上读取指定 query 参数
    getQueryString = name => {
        return (
            decodeURIComponent(
                (new RegExp(`[?|&]${name}=` + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(
                    /\+/g,
                    '%20'
                )
            ) || null
        );
    };

    // 查询缓缴学费到期时间参数
    getHjxfdqsj = () => {
        this.getCssz(this.state.hjxfdqsj_csbz, (data) => {
            this.setState({ hjxfdqsj: data });
        });
    }

    // 获取参数设置
    getCssz = (csbz, callback) => {
        NHFetch(`/zzbdCommon/getCssz?csbz=${csbz}`, 'GET').then(res => {
            if (res && res.data) {
                callback(res.data);
            } else {
                message.error(`获取参数${csbz}失败`);
            }
        })
    }

    // 根据侧边菜单确定当前环节名称和下一步跳转地址
    setMenuList = menuList => {
        const bz = this.state.mkbz;
        let currentIndex = -1;
        menuList.forEach((elem, index) => {
            if (elem.HJDM === bz) {
                this.setState({ hjmc: elem.HJMC });
                currentIndex = index;
            }
        });
        const nextMenu = currentIndex >= 0 && currentIndex < menuList.length - 1 ? menuList[currentIndex + 1] : null;
        const nextStep = buildMenuStepUrl(nextMenu);
        this.setState({
            nextUrl: nextStep.url,
            search: nextStep.search,
        });
    };

    // 确认通知后解锁表单
    onConfirmNotice = () => {
        this.setState({
            noticeVisible: false,
            noticeConfirmed: true,
            hasSaved: false,
        });
    };

    // 取消通知后返回上一页
    onCancelNotice = () => {
        window.history.back();
    };

    // 切换“是否需要缓缴学费”并触发金额联动
    onNeedLateFeeChange = value => {
        const { form } = this.props;
        this.setState({ needLateFee: value });
        if (value === '0') {
            form.setFieldsValue({ hjxfje: undefined });
        }
        this.updateSjfyDebounced();
    };

    // 切换“是否办理助学贷款”并重置关联字段
    onLoanTypeChange = value => {
        const { form } = this.props;
        if (value === '0') {
            form.setFieldsValue({
                zxdkje: undefined,
                blyh: undefined,
                jtyh: undefined,
                dkyhmc: undefined,
            });
        }
        this.updateSjfyDebounced();
    };

    // 切换办理银行时联动清空具体银行/银行名称
    onBlyhChange = value => {
        const { form } = this.props;
        if (value === BLYH_GJKFYH) {
            form.setFieldsValue({ jtyh: undefined, dkyhmc: undefined });
        }
        this.updateSjfyDebounced();
    };

    // 切换具体银行时，非“其他”则清空银行名称
    onJtyhChange = value => {
        const { form } = this.props;
        if (value !== 'qt') {
            form.setFieldsValue({ dkyhmc: undefined });
        }
        this.updateSjfyDebounced();
    };

    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    showPreview = url => {
        this.setState({
            previewImage: url,
            previewVisible: true,
        });
    };

    handlePreview = file => {
        console.log('file', file)
        const isImage = /^image\/.*$/i.test(file.type);
        if (isImage) {
            if (file.originFileObj) {
                this.getBase64(file.originFileObj, imageUrl => {
                    this.setState({
                        previewImage: imageUrl,
                        previewVisible: true,
                    });
                });
            } else {
                this.setState({
                    previewImage: file.url || file.thumbUrl,
                    previewVisible: true,
                });
            }
        } else if (file && file.response && file.response.data) {
            let imgFlag = true;
            const fjmc = file.response.data.fjmc;
            const ssbh = file.response.data.ssbh;
            if (!this.setJudge(fjmc, this.state.judgeImgList)) {
                imgFlag = false;
            }
            if (imgFlag) {
                this.showPreview(`anonymity/docrepo/download/file?attachmentId=${ssbh}`);
            } else {
                window.open(`anonymity/docrepo/download/file?attachmentId=${ssbh}`);
            }
        }
    };

    // 点击文件链接或预览图标时的回调
    handleFilePreview = (fjmc, fjid) => {
        let isImage = true;
        if (
            !this.setJudge(fjmc,this.state.judgeImgList)
        ) {
            isImage = false;
        }
        if (isImage) {
            window.open(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
            this.props.showPreview(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        } else {
            window.open(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        }
    };

    handleCancel = () => this.setState({ previewVisible: false });

    /** Upload 绑定 fileList 时，表单里应存数组；兼容历史 { fileList } 结构 */
    getFjFileList = fj => {
        if (Array.isArray(fj)) {
            return fj;
        }
        if (fj && Array.isArray(fj.fileList)) {
            return fj.fileList;
        }
        return [];
    };

    handleChange = info => {
        const fileList = info && info.fileList ? info.fileList : [];
        // 与 channel 绿色通道页一致：表单存 { fileList }，避免 Upload 收到非数组导致 fileList.some 报错
        this.props.form.setFieldsValue({ fj: { fileList } });
        this.setState({ fileList });
        let count = 0;
        fileList.forEach(elem => {
            if (elem && elem.status === 'uploading') {
                this.setState({ uploading: true });
                return;
            }
            if (elem && elem.status) {
                count += 1;
            }
        });
        if (count > 0) {
            this.setState({ uploading: false });
        }
    };

    setJudge = (name, map) => {
        let flag = false;
        map.forEach(item => {
            if (name.indexOf(item) !== -1) {
                flag = true;
            }
        });
        return flag;
    };

    beforeUpload = file => {
        if (
            !(
                this.setJudge(file.name, this.state.judgeImgList) ||
                this.setJudge(file.name, this.state.judgeFileList)
            )
        ) {
            message.error('不能上传该格式文件');
            return false;
        }
        return true;
    };

    remove = ssbh => {
        const url = `api/docrepo/attachment/sourceId/delete?souerceId=${ssbh}`;
        NHFetch(url, 'POST').then(res => {
            if (res && res.data && res.data > 0) {
                message.success('已删除材料.');
            }
        });
    };

    /** 办理原因 blyy 是否包含「其他」码 99（兼容 Checkbox 数组或回显字符串/逗号分隔） */
    blyyIncludesOther = blyy => {
        if (blyy == null || blyy === '') {
            return false;
        }
        if (Array.isArray(blyy)) {
            return blyy.some(v => String(v).trim() === '99');
        }
        return String(blyy)
            .split(/[,，]/)
            .map(s => s.trim())
            .includes('99');
    };

    // 表单校验通过后标记为已保存，用于控制“保存/下一步”互斥展示
    onSave = () => {
        const { form } = this.props;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            if (this.blyyIncludesOther(values.blyy)) {
                const sqsm = values.sqsm;
                const sqsmStr = sqsm != null ? String(sqsm).trim() : '';
                if (!sqsmStr) {
                    form.setFields({
                        sqsm: {
                            value: sqsm,
                            errors: [new Error('办理原因为其他时，申请理由不可为空')],
                        },
                    });
                    return;
                }
            }
            const fj = values.fj;
            const fileList = this.getFjFileList(fj);
            const isEmpty = fileList.length === 0;

            if (isEmpty) {
                form.setFields({
                    fj: {
                        value: undefined,
                        errors: [new Error('请上传材料证明')],
                    },
                });
                return;
            }

            const size = fileList.length;
            const file = fileList.filter(f => {
                if (f.status === 'error') {
                    message.warning('材料上传出错，请重新上传');
                    return false;
                }
                return true;
            });
            if (file.length !== size) {
                form.setFields({
                    fj: {
                        value: fj && typeof fj === 'object' ? fj : { fileList },
                        errors: [new Error('材料上传出错，请重新上传.')],
                    },
                });
                return;
            }
            const fjlist = [];
            for (let i = 0; i < fileList.length; i += 1) {
                const item = fileList[i];
                if (!item.response || !item.response.data || item.response.data.ssbh == null) {
                    message.error('文件尚未上传完成，请稍候再试');
                    return;
                }
                fjlist.push({
                    fjid: item.response.data.ssbh,
                    fjmc: item.name,
                });
            }

            const params = { ...values };
            params.zzbdhjid = this.getQueryString('pkid');
            params.fj = fjlist;
            NHFetch('/tjstsxy/saveChannel', 'POST', params).then(res => {
                if (res && res.code === 200 && res.data === 1) {
                    this.setState({ hasSaved: true, linkHandled: true });
                    message.success('已成功提交绿色通道申请，实际交纳费用请在申请审批通过后，请随时关注审批进度！');
                } else {
                    message.error('办理失败！');
                }
            });
        });
    };

    render() {
        const { form } = this.props;
        const { getFieldDecorator } = form;
        const {
            loading,
            nextUrl,
            search,
            hjmc,
            noticeVisible,
            noticeConfirmed,
            needLateFee,
            hjxfdqsj,
            feeDetailList,
            linkHandled,
            previewVisible,
            previewImage,
            data,
            echoFormReady,
            checkGroup,
            auditData,
        } = this.state;
        const formDisabled = !noticeConfirmed || linkHandled;
        const sfblzxdk = form.getFieldValue('sfblzxdk');
        const blyh = form.getFieldValue('blyh');
        const jtyh = form.getFieldValue('jtyh');
        // 已办理仅查看时 formDisabled 为 true，但仍需按「是否办理助学贷款」展示银行相关项（仅禁用不可编辑）
        const showBankBlock = sfblzxdk === '1' && (!formDisabled || linkHandled);
        // 未办理：显示办理银行；已办理：不显示办理银行，仅显示具体银行+具体银行名称（数据来自 queryChannel 的 DKYH/DKYHMC）
        const showBlyhField = !linkHandled && showBankBlock;
        const showJtyhEdit = !linkHandled && showBankBlock && (blyh === BLYH_QT_SYYH || blyh === BLYH_QT_YSYH);
        const showJtyhView = linkHandled && showBankBlock;
        const showJtyh = showJtyhEdit || showJtyhView;
        const jtyhNorm = String(jtyh || '');
        const dkyhNorm = String(data?.DKYH || '');
        const isQtBank = jtyhNorm === 'qt' || dkyhNorm === 'qt';
        const showDkyhmcEdit = showJtyhEdit && isQtBank;
        const dkyhmcVal = form.getFieldValue('dkyhmc');
        const dkyhmcRaw = data && (data.DKYHMC != null ? data.DKYHMC : data.dkyhmc);
        const dkyhmcFromData =
            dkyhmcRaw != null && String(dkyhmcRaw).trim() !== '' ? String(dkyhmcRaw).trim() : '';
        const hasDkyhmc =
            (dkyhmcVal != null && String(dkyhmcVal).trim() !== '') || dkyhmcFromData !== '';
        // 已办理查看：有名称则展示；具体银行为「其他 qt」时无论名称是否为空都展示（与办理中逻辑一致）
        const showDkyhmcView = linkHandled && showBankBlock && (hasDkyhmc || isQtBank);
        const showDkyhmc = showDkyhmcEdit || showDkyhmcView;
        const auditList = Array.isArray(auditData) ? auditData : [];
        const auditProcessEnded =
            auditList.length > 0 && String(auditList[auditList.length - 1].SZJD || '').trim() === '结束';

        const props = {
            name: 'file',
            action: 'anonymity/docrepo/upload',
            data: { uuid: createUuid(), type: '1' },

            onRemove: file => {
                this.setState(({ fileList }) => {
                    const index = fileList.indexOf(file);
                    const newFileList = fileList.slice();
                    if (index >= 0) {
                        newFileList.splice(index, 1);
                    }
                    this.props.form.setFieldsValue({ fj: { fileList: newFileList } });
                    return { fileList: newFileList };
                }, () => {
                    if (file.response && file.response.data && file.response.data.ssbh) {
                        this.remove(file.response.data.ssbh);
                    }
                });
            },
            beforeUpload: file => {
                if (!this.beforeUpload(file)) {
                    return false;
                }
                this.setState(({ fileList }) => ({
                    fileList: [...fileList, file],
                }));
                return true;
            },
            onChange: info => {
                this.handleChange(info);
            },
            onPreview: this.handlePreview,
            fileList: this.state.fileList,
        };

        return (
            <div className="page_pay">
                <Flex className="w1180 mt-20" align="start">
                    <SiderMenu
                        ref="siderMenu"
                        setMenuList={this.setMenuList}
                        title="自助报到"
                        mkbz={this.state.mkbz}
                        menuType="自助报到"
                    />
                    <Flex.Item className="page_con_r">
                        <Breadcrumb
                            noLine
                            list={[
                                { name: '首页', url: '/index' },
                                { name: '自助报到', url: '/register' },
                                { name: hjmc },
                            ]}
                        />
                        <div className="box">
                            <Hint />
                            <TitleTop title={hjmc || '绿色通道'} extra={false} />
                            <Spin spinning={loading}>
                                <div className="channelTjstsxy-wrap p-sw mt-20">
                                    <div className="channelTjstsxy-feeSection">
                                        <div className="channelTjstsxy-sectionTitle">收费明细</div>
                                        <Table
                                            rowKey={record => record.SFXMID || record.ROW_ID}
                                            columns={this.feeDetailColumns}
                                            dataSource={feeDetailList}
                                            pagination={false}
                                            size="middle"
                                            locale={{ emptyText: '暂无收费明细' }}
                                        />
                                    </div>
                                    <div className="channelTjstsxy-feeSection">
                                        <div className="channelTjstsxy-sectionTitle">申请信息</div>
                                        {linkHandled && !echoFormReady ? (
                                            <div style={{ textAlign: 'center', padding: '48px 0' }}>
                                                <Spin />
                                            </div>
                                        ) : (
                                            <Form key={linkHandled ? 'channel-echo' : 'channel-edit'}>
                                                <NHFormItem
                                                    id={'sfblzxdk'}
                                                    label={'是否办理助学贷款'}
                                                    form={form}
                                                    required={true}
                                                    initialValue={this.initEcho(d => (d.SFBLZXDK != null ? String(d.SFBLZXDK) : undefined))}
                                                >
                                                    <NHSelect
                                                        sign={"DMK_YXXT_LSTD_BLZT"}
                                                        placeholder="请选择"
                                                        disabled={formDisabled}
                                                        onChange={this.onLoanTypeChange}
                                                    />
                                                </NHFormItem>
                                                <NHFormItem
                                                    id={'blyy'}
                                                    required={true}
                                                    showFlag={sfblzxdk === '1'}
                                                    form={form}
                                                    initialValue={formDisabled ? data?.BLYY : undefined}
                                                    // formItemLayout={{ labelCol: { span: 4 }, wrapperCol: { span: 16 } }}
                                                    label="办理原因">
                                                    {
                                                        !formDisabled ?
                                                            <CheckboxGroup style={{ width: '100%' }} disabled={formDisabled}>{this.state.checkGroup}</CheckboxGroup>
                                                            : <Input disabled />
                                                    }
                                                </NHFormItem>
                                                <NHFormItem
                                                    id={'yjxf'}
                                                    label={'应缴学费'}
                                                    form={form}
                                                    initialValue={this.getYjxfDisplayValue(feeDetailList)}
                                                >
                                                    <Input placeholder="系统自动带出" disabled />
                                                </NHFormItem>
                                                <NHFormItem
                                                    id={'zxdkje'}
                                                    label={'助学贷款金额'}
                                                    form={form}
                                                    required={sfblzxdk === '1'}
                                                    showFlag={sfblzxdk === '1'}
                                                    initialValue={this.initEcho(d => {
                                                        const blje = d.BLJE != null ? d.BLJE : d.blje;
                                                        if (blje == null || blje === '') {
                                                            return undefined;
                                                        }
                                                        return this.toAmountNumber(blje);
                                                    })}
                                                >
                                                    <InputNumber
                                                        placeholder="请输入助学贷款金额"
                                                        disabled={formDisabled || form.getFieldValue('sfblzxdk') === '0'}
                                                        onChange={this.updateSjfyDebounced}
                                                        min={0}
                                                        max={50000}
                                                        precision={2}
                                                        style={{ width: '100%' }}
                                                    />
                                                </NHFormItem>
                                                <NHFormItem
                                                    id={'blyh'}
                                                    label={'办理银行'}
                                                    form={form}
                                                    required={showBlyhField}
                                                    showFlag={showBlyhField}
                                                >
                                                    <Select
                                                        placeholder="请选择办理银行"
                                                        disabled={formDisabled}
                                                        onChange={this.onBlyhChange}
                                                    >
                                                        <Option value={BLYH_QT_SYYH}>其他商业银行</Option>
                                                        <Option value={BLYH_QT_YSYH}>其他预设银行</Option>
                                                        <Option value={BLYH_GJKFYH}>国家开发银行</Option>
                                                    </Select>
                                                </NHFormItem>
                                                <NHFormItem
                                                    id={'jtyh'}
                                                    label={'具体银行'}
                                                    form={form}
                                                    required={showJtyhEdit}
                                                    showFlag={showJtyh}
                                                    initialValue={this.initEcho(d =>
                                                        d.DKYH != null && String(d.DKYH).trim() !== ''
                                                            ? String(d.DKYH).trim()
                                                            : undefined
                                                    )}
                                                >
                                                    <NHSelect
                                                        sign={"DMK_YXWZ_DKYH"}
                                                        placeholder="请选择具体银行"
                                                        disabled={formDisabled}
                                                        onChange={this.onJtyhChange}
                                                    />
                                                </NHFormItem>
                                                <NHFormItem
                                                    id={'dkyhmc'}
                                                    label={'具体银行名称'}
                                                    form={form}
                                                    initialValue={this.initEcho(d => {
                                                        const mc = d.DKYHMC != null ? d.DKYHMC : d.dkyhmc;
                                                        if (mc == null || String(mc).trim() === '') {
                                                            return undefined;
                                                        }
                                                        return String(mc).trim();
                                                    })}
                                                    required={showDkyhmcEdit}
                                                    showFlag={showDkyhmc}
                                                >
                                                    <Input placeholder="请输入具体银行名称" disabled={formDisabled} maxLength={100} />
                                                </NHFormItem>
                                                <NHFormItem
                                                    id={'hzjym'}
                                                    form={form}
                                                    label="回执校验码"
                                                    required={showBlyhField}
                                                    showFlag={showBlyhField}
                                                    initialValue={this.initEcho(d =>
                                                        d.HZJYM != null && String(d.HZJYM).trim() !== ''
                                                            ? String(d.HZJYM).trim()
                                                            : undefined
                                                    )}
                                                >
                                                    <Input maxLength={6} placeholder="6位数回执校验码" disabled={formDisabled} />
                                                </NHFormItem>
                                                <NHFormItem
                                                    id={'dkhtbh'}
                                                    form={form}
                                                    pattern={{ pattern: /^[A-Za-z0-9]{1,99}$/, message: "只能输入数字和字母" }}
                                                    label="贷款合同编号"
                                                    required={showBlyhField}
                                                    showFlag={showBlyhField}
                                                    initialValue={this.initEcho(d =>
                                                        d.DKHTBH != null && String(d.DKHTBH).trim() !== ''
                                                            ? String(d.DKHTBH).trim()
                                                            : undefined
                                                    )}
                                                >
                                                    <Input placeholder="贷款合同编号" disabled={formDisabled} />
                                                </NHFormItem>
                                                <NHFormItem
                                                    id={'sqsm'}
                                                    form={form}
                                                    label="申请理由"
                                                    showFlag={showBlyhField}
                                                    initialValue={this.initEcho(d =>
                                                        d.SQSM != null && String(d.SQSM).trim() !== ''
                                                            ? String(d.SQSM).trim()
                                                            : undefined
                                                    )}
                                                >
                                                    <Input.TextArea maxLength={100} placeholder="请填写申请理由（办理原因为其他时此项不可为空）" disabled={formDisabled} />
                                                </NHFormItem>
                                                <NHFormItem
                                                    id={'sfblhjxf'}
                                                    label={'是否需要办理缓缴学费'}
                                                    form={form}
                                                    required={true}
                                                    initialValue={linkHandled ? this.initEcho(d => (d.SFBLHJXF != null ? String(d.SFBLHJXF) : undefined)) || '0' : '0'}
                                                >
                                                    <Select
                                                        placeholder="请选择"
                                                        disabled={formDisabled}
                                                        onChange={this.onNeedLateFeeChange}
                                                    >
                                                        <Option value="1">是</Option>
                                                        <Option value="0">否</Option>
                                                    </Select>
                                                </NHFormItem>
                                                <NHFormItem
                                                    id={'hjxfje'}
                                                    label={'缓缴学费'}
                                                    form={form}
                                                    required={needLateFee === '1'}
                                                    showFlag={needLateFee === '1'}
                                                    initialValue={this.initEcho(d => {
                                                        if (d.HJXFZSFJE == null || d.HJXFZSFJE === '') {
                                                            return undefined;
                                                        }
                                                        return this.toAmountNumber(d.HJXFZSFJE);
                                                    })}
                                                >
                                                    <InputNumber
                                                        placeholder="请输入缓缴学费"
                                                        disabled={formDisabled || needLateFee === '0'}
                                                        onChange={this.updateSjfyDebounced}
                                                        min={0}
                                                        precision={2}
                                                        style={{ width: '100%' }}
                                                    />
                                                </NHFormItem>
                                                <NHFormItem
                                                    id={'sjfy'}
                                                    label={'实缴费用'}
                                                    form={form}
                                                    initialValue={linkHandled ? this.getEchoSjfyDisplayValue() : undefined}
                                                >
                                                    <Input placeholder="系统自动带出" disabled />
                                                </NHFormItem>
                                                <NHFormItem id={'hjxfdqsj'} label={'缓缴学费到期时间'} form={form} initialValue={moment(new Date(hjxfdqsj), 'yyyy-MM-dd HH:mm:ss')}>
                                                    <DatePicker disabled={true} />
                                                </NHFormItem>
                                                {!linkHandled && sfblzxdk === '1' ? (
                                                    <div className="channelTjstsxy-uploadBlock">
                                                        <div className="channelTjstsxy-sectionTitle" style={{ marginBottom: 12 }}>申请材料</div>
                                                        <FormItem
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            label="上传材料证明"
                                                            required
                                                        >
                                                            {getFieldDecorator('fj', {
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: '请上传材料证明',
                                                                    },
                                                                ],
                                                            })(
                                                                <Dragger {...props}>
                                                                    <p className="ant-upload-drag-icon">
                                                                        <Icon type="inbox" />
                                                                    </p>
                                                                    <Spin spinning={this.state.uploading} />
                                                                    <p className="ant-upload-text font-14">
                                                                        点击此处或拖拽文件到此
                                                                    </p>
                                                                </Dragger>
                                                            )}
                                                        </FormItem>
                                                    </div>
                                                ) : data.SFBLZXDK == '1' && <div className="p-sw">
                                                    <div className="form_item" style={{ width: '100%' }}>
                                                        <Row gutter={24}>
                                                            <Col span={4} style={{ textAlign: 'right', paddingRight: 0 }}><span
                                                                style={{ color: 'rgba(0, 0, 0, 0.85)' }}>材料证明&nbsp;: </span></Col>
                                                            <Col span={20}>
                                                                {data.fj && data.fj.map((elem, index) => {
                                                                    return (
                                                                        <div style={{ marginBottom: '20px' }}>
                                                                            <a onClick={() => {
                                                                                this.handleFilePreview(elem['fjmc'], elem['fjid']);
                                                                            }}>{elem['fjmc']}</a>
                                                                        </div>
                                                                    )
                                                                })
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                                }
                                                {linkHandled && auditList.length > 0 ? (
                                                    <div className="channelTjstsxy-auditBlock">
                                                        <div className="channelTjstsxy-sectionTitle" style={{ marginBottom: 8 }}>
                                                            审核流程
                                                        </div>
                                                        <Steps
                                                            direction="vertical"
                                                            size="small"
                                                            className="channelTjstsxy-auditSteps"
                                                        >
                                                            {auditList.map((item, idx) => (
                                                                <Step
                                                                    key={
                                                                        item.PKID ||
                                                                        `${idx}_${item.SHSJ || ''}_${item.SZJD || ''}`
                                                                    }
                                                                    title={
                                                                        <span className="channelTjstsxy-auditStepTitle">
                                                                            {item.SZJD || '—'}
                                                                        </span>
                                                                    }
                                                                    status={
                                                                        isEndAuditNode(item)
                                                                            ? 'finish'
                                                                            : getAuditStepStatus(item)
                                                                    }
                                                                    description={
                                                                        isEndAuditNode(item) ? null : (
                                                                            <div className="channelTjstsxy-auditStepDesc">
                                                                                <div className="channelTjstsxy-auditStepRow">
                                                                                    <span className="channelTjstsxy-auditStepLabel">审核结果</span>
                                                                                    <span className={getAuditStepResultClassName(item)}>
                                                                                        {item.SHLXMC || '—'}
                                                                                    </span>
                                                                                </div>
                                                                                <div className="channelTjstsxy-auditStepRow">
                                                                                    <span className="channelTjstsxy-auditStepLabel">审核人</span>
                                                                                    <span className="channelTjstsxy-auditStepValue">
                                                                                        {item.SHRXM || '—'}
                                                                                    </span>
                                                                                </div>
                                                                                <div className="channelTjstsxy-auditStepRow">
                                                                                    <span className="channelTjstsxy-auditStepLabel">审核时间</span>
                                                                                    <span className="channelTjstsxy-auditStepValue">
                                                                                        {item.SHSJ || '—'}
                                                                                    </span>
                                                                                </div>
                                                                                {item.SHYJ != null && String(item.SHYJ).trim() !== '' ? (
                                                                                    <div className="channelTjstsxy-auditStepRow">
                                                                                        <span className="channelTjstsxy-auditStepLabel">审核意见</span>
                                                                                        <span className="channelTjstsxy-auditStepValue is-multiline">
                                                                                            {String(item.SHYJ).trim()}
                                                                                        </span>
                                                                                    </div>
                                                                                ) : null}
                                                                            </div>
                                                                        )
                                                                    }
                                                                />
                                                            ))}
                                                        </Steps>
                                                    </div>
                                                ) : null}
                                            </Form>
                                        )}
                                    </div>
                                    <div className="channelTjstsxy-action">
                                        {formDisabled ? (
                                            // 未确认通知时由 Modal 强制确认，按钮只保留“下一步”以满足互斥显示
                                            <NextButton nextUrl={nextUrl} search={search} />
                                        ) : this.state.hasSaved ? (
                                            <NextButton nextUrl={nextUrl} search={search} />
                                        ) : (
                                            <Button type="primary" onClick={this.onSave}>
                                                保存
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            </Spin>
                        </div>
                    </Flex.Item>
                </Flex>
                <Modal
                    visible={noticeVisible}
                    title="通知"
                    okText="确认"
                    cancelText="取消"
                    closable={false}
                    maskClosable={false}
                    onOk={this.onConfirmNotice}
                    onCancel={this.onCancelNotice}
                >
                    <div className="channelTjstsxy-noticeContent">{buildNoticeContent(hjxfdqsj)}</div>
                </Modal>
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                    <img alt="预览" style={{ width: '100%' }} src={previewImage} />
                </Modal>
            </div>
        );
    }
}
